import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { IUpdateBankDetails } from 'Interfaces/updateBankDetails';
import { requiredMessage } from 'Regex';
import {
  bankAccountOwnershipErrorMessage,
  bankAccountValidation,
  bankAccountValidationErrorMessage,
} from 'Utils';
import * as yup from 'yup';

export const UpdateBankDetailsSchema = (
  bankNumber?: number,
  branchNumber?: number
) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UpdateBankDetails);

  return yup.object().shape({
    bankId: yup
      .number()
      .required(`${requiredMessage} ${dictionary.inputLabel1}`),
    branchId: yup
      .number()
      .required(`${requiredMessage} ${dictionary.inputLabel2}`),
    accountNum: yup
      .string()
      .required(`${requiredMessage} ${dictionary.inputLabel3}`)
      .test(
        'isValid',
        bankAccountValidationErrorMessage,
        (accountNumber: any) => {
          if (!bankNumber || !branchNumber) return false;

          return bankAccountValidation(
            bankNumber,
            branchNumber,
            parseInt(accountNumber)
          );
        }
      ),
    isOwner: yup.bool().oneOf([true], bankAccountOwnershipErrorMessage),
  }) as yup.SchemaOf<IUpdateBankDetails>;
};
